import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["className", "color", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import DSIconTabsCaretRight from '@lmig/design-system-icons-react/_cjs/system/TabsCaretRight';
import "../icons.css";
var IconTabsCaretRight = function IconTabsCaretRight(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'blue' : _ref$color,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Tabs Caret Right' : _ref$title,
    iconProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(DSIconTabsCaretRight, _extends({
    className: className,
    color: color,
    title: title
  }, iconProps));
};
IconTabsCaretRight.propTypes = {
  /** Add an optional ID to this element: `<svg class="lm-Icon">`. */id: _pt.string,
  /** Apply a color to the icon.
     * @default 'blue'
     */
  color: _pt.oneOf(['blue', 'caution', 'disabled', 'error', 'gray', 'informative', 'inverse', 'negative', 'positive', 'success', 'teal']),
  /** Specifies the actual size of the inner svg icon.
     * @default '16'
     */
  size: _pt.oneOf(['16']),
  /** Hide icon from screen readers.
     * @default false
     */
  ariaHidden: _pt.bool,
  /** Add custom classes to this element: `<svg class="lm-Icon">`. */className: _pt.string,
  /** Similar to the "alt" attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */title: _pt.string
};
export default IconTabsCaretRight;